export default __webpack_public_path__ + "img/graphic-layer-3aafdff7d196b903d6c1ca979076376f.png";